import script from "./AppMain.vue?vue&type=script&setup=true&lang=js"
export * from "./AppMain.vue?vue&type=script&setup=true&lang=js"

import "./AppMain.vue?vue&type=style&index=0&id=32190c1f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.store/vue-loader@17.3.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32190c1f"]])

export default __exports__